import React, { memo, forwardRef } from "react";
const SvgAlphabetI = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M17.54 10.2c0 .413-.153.76-.46 1.04-.293.267-.66.4-1.1.4-.44 0-.807-.14-1.1-.42a1.432 1.432 0 01-.42-1.02c0-.387.14-.72.42-1 .293-.293.66-.44 1.1-.44.44 0 .807.14 1.1.42.307.267.46.607.46 1.02zm-.34 11.7c0 .28-.047.513-.14.7a.97.97 0 01-.32.4.909.909 0 01-.4.18 1.22 1.22 0 01-.34.06c-.107 0-.227-.02-.36-.06a1.064 1.064 0 01-.4-.18 1.243 1.243 0 01-.32-.4c-.08-.187-.12-.42-.12-.7v-7.28c0-.28.04-.507.12-.68a1.2 1.2 0 01.32-.42c.133-.093.267-.153.4-.18.133-.04.253-.06.36-.06.093 0 .207.02.34.06.147.027.28.087.4.18.133.093.24.233.32.42.093.173.14.4.14.68v7.28z"
      />
    </svg>
  );
});
SvgAlphabetI.displayName = "SvgAlphabetI";
const MemoForwardRef = memo(SvgAlphabetI);
export default MemoForwardRef;
